module.exports = {render: function () {with(this){return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}},[_c('path',{attrs:{"d":"M30.2 9.3l-13.1 3.8c-.6.2-1.3-.3-1.3-1v-4c0-.8-.8-1.3-1.5-.9L1 14.9c-.7.4-.7 1.4 0 1.7l13.3 7.7c.7.4 1.5-.1 1.5-.9v-4.1c0-.7.6-1.2 1.3-1l13.1 3.8c.6.2 1.3-.3 1.3-1v-11c0-.5-.6-1-1.3-.8z"}})])}}};


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fast-forward.svg
// module id = 438
// module chunks = 1